module.exports = __webpack_public_path__ + "static/media/3.b6a7fdef.png";